import moment from "moment";

const IntlDateFormatter = (date, language) => {
  if (window.Intl && language) {
    // locales should be written as en_gb, not en-gb
    return new Intl.DateTimeFormat(language.replace(/_/g, '-')).format(date);
  } else {
    return moment(date).format("MM/DD/YYYY");
  }
};

export default IntlDateFormatter;
